import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = 'content';

export type contentList = {
    content_type: string;
    keyword?: string;
    start_date?: string;
    end_date?: string;
    limit?: number;
    page?: number;
    sortBy?: string;
    sortType?: string;
    journal_type?: string;
    banner_type?: string;
    content_status_name?: string;
    id_category?: number;
    id_activity_category?: number;
}
export type contentDataType = {
    id_activity_category?: number | null;
    is_public: boolean;
    content_start_date: string; // Format: YYYY-MM-DD
    content_end_date: string;   // Format: YYYY-MM-DD
    content_start_time?: string; // Format: HH:mm:ss
    content_end_time?: string;   // Format: HH:mm:ss
    activity_start_date?: string;
    activity_end_date?: string;
    activity_start_time?: string;
    activity_end_time?: string;
    banner_type: string;
    content_name: string;
    content_detail: string;
    content_type: string;
    content_status_name: string;
    content_desc: string;
    status?: string;
    content_tags: {
        id_tag: number
    }[]
    content_files: {
        id_media_file: number;
    }[];
    content_categorys: {
        id_category: number
    }[];
    content_vdo_files?: { id_content_vdo_file: number, link?: string }[];

};



export class ContentApi extends BaseAPI {
    static list(query: contentList): Promise<AxiosResponse> {
        return this.api.get(`${path}`, { params: { ...query } })
    }
    static findOne(id_content: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_content}`)
    }
    static create(body: contentDataType): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static update(id_content: number, body: contentDataType): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_content}`, body)
    }
    static delete(id_content: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_content}`)
    }
    static updateStatusContent(id_content: number, body: { status: string }): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_content}/status`, body)
    }
    static updateStatus(id_content: number, body: { is_public: number }): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_content}/update-is-public`, body)
    }
    static createVdoFile(file: FormData): Promise<AxiosResponse> {
        return this.api.post(`${path}/vdo_file`, file, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
    static deleteVdo(id_content_vdo_file: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/vdo_file/${id_content_vdo_file}`)
    }
}